var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttributeFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_45310_201015)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8664 0.394531H1.86469C1.12825 0.394531 0.53125 0.991533 0.53125 1.72797V22.7297C0.53125 23.4661 1.12825 24.0631 1.86469 24.0631H22.8664C23.6028 24.0631 24.1998 23.4661 24.1998 22.7297V1.72797C24.1998 0.991533 23.6028 0.394531 22.8664 0.394531Z",
    stroke: "#D9D9D9",
    strokeWidth: 0.33336
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8712 18.8984H3.86981C3.77775 18.8984 3.70312 18.9731 3.70312 19.0651C3.70312 19.1572 3.77775 19.2318 3.86981 19.2318H20.8712C20.9632 19.2318 21.0379 19.1572 21.0379 19.0651C21.0379 18.9731 20.9632 18.8984 20.8712 18.8984Z",
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_45310_201015)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0395 5.67188H6.03914C5.48681 5.67188 5.03906 6.10968 5.03906 6.64973V14.4726C5.03906 15.0126 5.48681 15.4504 6.03914 15.4504H12.0396C12.592 15.4504 13.0397 15.0126 13.0397 14.4726V8.60545L10.0395 5.67188Z",
    stroke: "#4D4D4D",
    strokeWidth: 0.600049,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0391 5.67188V8.60545H13.0393",
    stroke: "#4D4D4D",
    strokeWidth: 0.600049,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.03906 10.1172V13.4508",
    stroke: "#4D4D4D",
    strokeWidth: 0.600049,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6658 11.747L9.03601 10.1172L7.40625 11.747",
    stroke: "#4D4D4D",
    strokeWidth: 0.600049,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_45310_201015"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.002,
    height: 24.002,
    fill: "white",
    transform: "translate(0.367188 0.226562)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_45310_201015"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.6675,
    height: 10.6675,
    fill: "white",
    transform: "translate(3.70312 5.23047)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttributeFileIcon);
export default __webpack_public_path__ + "static/media/attribute-file-icon.7dd91922268a28ae4db439972ad0edc6.svg";
export { ForwardRef as ReactComponent };